var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.name === 'capacity-icon')?_c('img',{class:_vm.iconColor,attrs:{"src":require("../assets/capacity_logo.svg")}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }